<form 
    (ngSubmit)="$event.preventDefault(); saveReviewerInfo();"
    class="w-full h-full flex flex-col items-center justify-start gap-4 overflow-y-auto"
    [formGroup]="reviewerInfoForm"
>
    <div class="w-full overflow-y-auto px-1">                    
        <h2 class="pb-2 w-full oswald-font text-xl font-medium text-start">
            Reviewer Information
        </h2>
        <div class="w-full flex flex-col items-center gap-2 pb-4"> 

            <div class="w-full flex flex-col items-center text-start">
                <div class="w-full font-semibold">
                    <p>Form started (Date & Time): *</p>
                </div>
                <div class="w-full flex items-center gap-2">
                    <div class="relative">
                        <div class="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
                            <svg class="w-4 h-4 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                                <path d="M20 4a2 2 0 0 0-2-2h-2V1a1 1 0 0 0-2 0v1h-3V1a1 1 0 0 0-2 0v1H6V1a1 1 0 0 0-2 0v1H2a2 2 0 0 0-2 2v2h20V4ZM0 18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8H0v10Zm5-8h10a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2Z"/>
                            </svg>
                        </div>
                        <input id="datepicker-start-date" #datepickerStartDate name="date_started" type="text" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded block w-full ps-10 p-2">
                    </div>
                    <div class="relative">
                        <div class="absolute inset-y-0 end-0 top-0 flex items-center pe-3.5 pointer-events-none">
                            <svg class="w-4 h-4 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24">
                                <path fill-rule="evenodd" d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm11-4a1 1 0 1 0-2 0v4a1 1 0 0 0 .293.707l3 3a1 1 0 0 0 1.414-1.414L13 11.586V8Z" clip-rule="evenodd"/>
                            </svg>
                        </div>
                        <input type="time" formControlName="time_started" class="bg-gray-50 border leading-none border-gray-300 text-gray-900 text-sm rounded focus:ring-blue-500 focus:border-blue-500 block w-full p-2" min="09:00" max="18:00" required />
                    </div>
                </div>
            </div>

            <div *ngIf="this.currentContact" class="w-full flex flex-col items-start text-start gap-2">
                <div class="w-full flex items-center text-start gap-2">
                    <div class="w-fit font-semibold whitespace-nowrap">
                        <p>Person filling out form: </p>
                    </div>
                    <p class="w-full">{{ this.currentContact.name }}</p>
                </div>

                <div class="w-full flex items-center text-start gap-2">
                    <div class="w-fit font-semibold whitespace-nowrap">
                        <p>Email address: </p>
                    </div>
                    <p class="w-full">{{ this.currentContact.email }}</p>
                </div>
                <div class="w-full flex items-center text-start gap-2">
                    <div class="w-fit font-semibold whitespace-nowrap">
                        <p>Phone: </p>
                    </div>
                    <p class="w-full">{{ this.currentContact.workphone }}</p>
                </div>
                <div class="w-full flex items-center text-start gap-2">
                    <div class="w-fit font-semibold whitespace-nowrap">
                        <p>School or District Position: </p>
                    </div>
                    <p class="w-full">{{ this.currentContact.Title }}</p>
                </div>
            </div>

        </div>
        <div class="w-full flex flex-row gap-2 items-center justify-end">
            <button
                type="submit"
                class="w-20 flex items-center justify-center px-4 py-1.5 rounded-md border bg-gradient-to-b oswald-font text-white"
                [ngClass]="{
                    'border-nside-gray-100 from-nside-gray-100 to-nside-gray-200 cursor-not-allowed': this.reviewerInfoForm.invalid,
                    'border-nside-orange-100 from-nside-orange-300 to-nside-orange-400 hover:bg-gradient-to-b hover:from-nside-orange-100 hover:to-nside-orange-200': this.reviewerInfoForm.valid
                }"
                [disabled]="this.reviewerInfoForm.invalid"
            >
                Save
            </button>
        </div>
    </div>
</form>

<div *ngIf="loading">
    <spinner></spinner>
</div>